<template>
  <section class="place-list padding_20">
    <div class="common-search__header">
      <div class="common-search__title">
        场管理
      </div>
      <el-button type="primary"
                 plain
                 icon="el-icon-circle-plus"
                 @click="handleClickAction()">
        新建场
      </el-button>
    </div>
    <Search ref="placeSearch"
            :search-array="searchArray"
            @getData="getData" />
    <div class="list">
      <el-table :data="placeList" style="width: 100%">
        <template v-for="(ele, id) in columns">
          <el-table-column
            v-if="id < columns.length - 1"
            :key="id"
            :sortable="ele.sortable"
            :prop="ele.prop"
            :label="ele.label">
          </el-table-column>
          <el-table-column
            v-else
            :key="id"
            fixed="right"
            label="操作"
            width="80">
            <template slot-scope="scope">
              <el-button @click="handleClickAction(scope.row)" type="text" size="small">编 辑</el-button>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <Pagination @changePage="handlePage" :total="total" :current-page="page"/>
    </div>
  </section>
</template>

<script>
import Search from '@/components/common/Search.vue';
import Pagination from '@/components/Pagination/index.vue';
import { fetchplaceList } from '@/api/place';
import memorizeURL from '@/mixins/memorizeURL';

export default {
  mixins: [
    memorizeURL,
  ],
  components: {
    Search,
    Pagination,
  },
  methods: {
    handleClickAction(params) {
      this.$router.push({
        name: 'place.add',
        query: {
          id: (params && params.id) || '',
        },
      });
    },
    handlePage(page) {
      this.page = page;
      this.handleFetchPlaceList();
    },
    handleFetchPlaceList() {
      const { page, size, name } = this;
      fetchplaceList({
        page,
        size,
        name,
      })
        .then((res) => {
          if (res.data.list && res.data.list.length >= 0) {
            this.placeList = res.data.list;
            this.total = res.data.total;
          } else {
            this.$message.error(res.error_msg || '服务异常，请稍后重试～');
          }
        });
    },
    getData(data) {
      this.name = (data && data.name) || '';
      this.handleFetchPlaceList();
    },
  },
  created() {
    // 调用接口
    this.handleFetchPlaceList();
  },
  data() {
    return {
      name: this.$route.query.name || '',
      size: Number(this.$route.query.size || 20),
      page: Number(this.$route.query.page || 1),
      total: 0,
      columns: [
        {
          prop: 'name',
          label: '名称',
          sortable: false,
        },
        {
          prop: 'site_id',
          label: '客户',
          sortable: false,
        },
        {
          prop: 'desc',
          label: '描述',
          sortable: false,
        },
        {
          action: true,
          label: '操作',
        },
      ],
      searchArray: [
        {
          label: '场名称',
          props: 'name',
          type: 'input',
        },
      ],
      placeList: [],
      memorized: {
        queries: ['page', 'size', 'name'],
        triggerMethods: ['handleFetchPlaceList'],
      },
    };
  },
};
</script>

<style scoped lang="scss">
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.my-label-tasks__header {
  margin-bottom: 10px;
}
.list {
  margin: 25px 0;
  box-sizing: border-box;
  padding: 20px;
  overflow: hidden;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.place_detail {
  color: #2C2C2E;
}
</style>
